import React, {FC, PropsWithChildren} from 'react';

import {NewPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {ChromelessButton} from '../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {PopoverCoordinator} from '../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualContactModel} from '../../models/api/visualContactModel';
import {ContactCardLocationsEnum} from '../../store/panels/contacts/contactCard/contactCardPanelState';
import {ContactCardWrapperContainer} from './contactCardWrapperContainer';

interface ContactCardPreviewerProps {
  panelId: NewPanelId;
  visualContact: VisualContactModel;
}

export const ContactCardPreviewer: FC<PropsWithChildren<ContactCardPreviewerProps>> = ({
  panelId,
  visualContact,
  children,
}) => (
  <PopoverCoordinator
    renderButton={(isOpen) => <ChromelessButton isOpen={isOpen}>{children}</ChromelessButton>}
    renderModal={(popoverProps) => (
      <ContactCardWrapperContainer
        popoverProps={popoverProps}
        visualContact={visualContact}
        panelId={panelId}
        location={ContactCardLocationsEnum.SYNOPSIS}
      />
    )}
  />
);
